import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'
import { CoreButton } from 'src/components/core'
const ResourceBanner = ({ classes }) => {
  return (
    <div className={classes.bannerContainer}>
      <div className={classes.bannerContent}>
        <Typography className={classes.bannerText}>
          Create quizzes from your resources.{' '}
        </Typography>
        <Typography className={classes.bannerDescription}>
          With paid plans, you can upload PDFs and let AI generate questions
          based on your resources.
        </Typography>
        <CoreButton
          fullWidth
          onClick={() => {
            window.location.href = '/pricing'
          }}
        >
          See Plans & Upgrade
        </CoreButton>
      </div>
    </div>
  )
}

export default withStyles(styles)(ResourceBanner)
